import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';

import { Zone } from '@scenario/models/zone.model';
import { RootState } from '@store/create-store';

export interface RegionsState {
  regions: Zone[];
  isFetching: boolean;
  error?: string;
}

const initialState: RegionsState = {
  regions: [],
  isFetching: false,
};

export const regionsSlice = createSlice({
  name: 'regions',
  initialState,
  reducers: {
    retrieveRegions: state => {
      state.isFetching = true;
    },
    retrieveRegionsSuccess: (state, action: PayloadAction<Zone[]>) => {
      state.regions = [...action.payload].sort((a, b) => a.name.localeCompare(b.name) || a.alias.localeCompare(b.alias));
      state.isFetching = false;
    },
    retrieveRegionsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type RegionsViewModel = {
  regions: Zone[];
  isFetching: boolean;
  error?: string;
};

export const selectRegionsViewModel = createSelector(
  (state: RootState) => state,
  (state): RegionsViewModel => ({
    regions: state.regions.regions,
    isFetching: state.regions.isFetching,
    error: state.regions.error,
  }),
);
export const { retrieveRegions, retrieveRegionsSuccess, retrieveRegionsFailure } =
  regionsSlice.actions;

export default regionsSlice.reducer;
